import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  contentWrapper: {
    marginBottom: '3.8rem',
  },
  categoryWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: colors.neutral[700],
    borderBottom: '0.1rem solid #C1C7CD',
    marginBottom: '2.1rem',
  },
  groupName: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
  },
  categoryName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500,
    },
    color: colors.neutral[900],
    margin: [0],
    textTransform: 'uppercase',
  },
  editButton: {
    marginRight: '-3rem',
  },
  manageEmployersButton: {
    marginTop: '3rem',
    textTransform: 'uppercase',
    fontWeight: 700,
    padding: 0,
  },
  employerName: {
    paddingTop: '0.4rem',
    margin: [0],
    wordBreak: 'break-word',
    font: {
      size: '1.8rem',
      lineHeight: '2.8rem',
      weight: 400,
    },
  },
  employerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:not(:last-child)': {
      marginBottom: '1rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
